
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  data() {
    return {
      lng: lng,
      menu: {
        categories: [],
        menu_settings: {}
      },
      idpoi: this.$route.params.idpoi,
      currency: {
        euro: 'EUR',
        pound: 'GBP',
        dollar: 'USD'
      },
      info: {},
      poi: myApp.currentPoi || {
        info: {}
      }
    };
  },

  methods: {
    async translate(lng) {
      let q = [];
      let items = [];
      this.menu.categories.forEach(c => {
        c.items.forEach(item => {
          if (item.visible) {
            items.push({
              id: item.id,
              text: item.caption,
              type: 'caption'
            });
            items.push({
              id: item.id,
              text: item.description,
              type: 'description'
            });
            q.push(item.caption);
            q.push(item.description);
          }
        });
      });

      const originalLang = () => {
        items.forEach(e => {
          this.$('.item-' + e.id + '-' + e.type).html(e.text);
        });
      };

      if (lng !== '-') {
        const APIKey = 'AIzaSyB8AY9p2GiPEq4iQ7gNmh5IRqI7MfKyy28';
        const url = 'https://translation.googleapis.com/language/translate/v2?key=' + APIKey;
        const data = {
          target: lng,
          q: q,
          format: 'text'
        };
        const options = {
          method: 'POST',
          body: JSON.stringify(data),
          headers: {
            'Content-Type': 'application/json'
          }
        };
        let res = await fetch(url, options);

        if (res.ok) {
          let tr = await res.json();
          tr.data.translations.forEach((e, i) => {
            this.$('.item-' + items[i].id + '-' + items[i].type).html(e.translatedText);
          });
        } else {
          originalLang();
        }
      } else {
        originalLang();
      }
    },

    showImage(ev) {
      const self = this,
            app = this.$app,
            $ = this.$,
            cat = $(ev.target).data('categoriesIndex'),
            itm = $(ev.target).data('index'),
            images = self.menu.categories[cat].items[itm].images;
      console.log(cat, itm);

      if (images.length) {
        app.photoBrowser.create({
          photos: images,
          popupCloseLinkText: lng.close
        }).open();
      }
    },

    getMenu() {
      const self = this,
            app = this.$app,
            $ = this.$;
      myApp.server.get('imc/menu/' + self.idpoi).then(res => {
        for (let i in res.categories) {
          for (let ii in res.categories[i].items) {
            res.categories[i].items[ii].catIndex = i;
            res.categories[i].items[ii].images = res.categories[i].items[ii].images || (res.categories[i].items[ii].image ? [res.categories[i].items[ii].image] : []);
            let hasAllergens = false;

            for (let j in res.categories[i].items[ii].allergens) {
              if (res.categories[i].items[ii].allergens[j]) {
                hasAllergens = true;
                break;
              }
            }

            res.categories[i].items[ii].hasAllergens = hasAllergens;
          }
        }

        res.currency = self.currency[res.currency] ? self.currency[res.currency] : res.currency;
        self.$setState({
          menu: res,
          cur: res.currency
        }).then(() => {
          if (myApp.order) {
            for (let i in myApp.order) {
              const id = i.replace('#item-', '');
              const v = myApp.order[i].q || 0;
              $('#menu-item-q-' + id).text(v);
            }
          }
        });
      });
    },

    toggleAllergens(id) {
      const self = this,
            app = this.$app,
            $ = this.$;
      $('#menu-item-' + id).toggleClass('hidden');
    }

  },

  mounted() {
    const self = this,
          app = this.$app,
          $ = this.$;
    this.getMenu();
  },

  id: '5f4a22e0fe',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\n  <div class="page">\n    <div class="navbar">\n      <div class="navbar-bg"></div>\n      <div class="navbar-inner sliding">\n        <div class="left">\n          <a href="#" class="link back">\n            <i class="icon icon-back"></i>\n            <span class="if-not-md">Back</span>\n          </a>\n        </div>\n        <div class="title">';
      r += c(ctx_1.lng.ourMenu1, ctx_1);
      r += '</div>\n        <div class="right">\n          <a href="#" data-actions=".actions-translate" class="actions-open">\n            <img  width="28" src="static/img/flag_translate.png" alt=""/>\n          </a>\n        </div>\n      </div>\n    </div>\n    <div class="page-content">\n\n      <div class="actions-modal actions-translate">\n        <div class="list">\n          <ul>\n            <li>\n              <a href="#" @click="translate(\'en\')" class="item-link item-content actions-close">\n                <div class="item-media">\n                  <img width="28" src="static/img/flag_en.png" alt=""/>\n                </div>\n                <div class="item-inner">English</div>\n              </a>\n            </li>\n            <li>\n              <a href="#" @click="translate(\'fr\')"  class="item-link item-content actions-close">\n                <div class="item-media">\n                  <img width="28" src="static/img/flag_fr.png" alt=""/>\n                </div>\n                <div class="item-inner">Français</div>\n              </a>\n            </li>\n            <li>\n              <a href="#" @click="translate(\'it\')"  class="item-link item-content actions-close">\n                <div class="item-media">\n                  <img width="28" src="static/img/flag_it.png" alt=""/>\n                </div>\n                <div class="item-inner">Italiano</div>\n              </a>\n            </li>\n            <li>\n              <a href="#" @click="translate(\'es\')"  class="item-link item-content actions-close">\n                <div class="item-media">\n                  <img width="28" src="static/img/flag_es.png" alt=""/>\n                </div>\n                <div class="item-inner">Español</div>\n              </a>\n            </li>\n            <li>\n              <a href="#" @click="translate(\'de\')"  class="item-link item-content actions-close">\n                <div class="item-media">\n                  <img width="28" src="static/img/flag_de.png" alt=""/>\n                </div>\n                <div class="item-inner">Deutsche</div>\n              </a>\n            </li>\n            <li>\n              <a href="#" @click="translate(\'-\')"  class="item-link item-content actions-close">\n                <div class="item-media">\n                  <img width="28" src="static/img/flag_translate.png" alt=""/>\n                </div>\n                <div class="item-inner text-color-imc">';
      r += c(ctx_1.lng.originalLanguage, ctx_1);
      r += '</div>\n              </a>\n            </li>\n          </ul>\n        </div>\n      </div>\n\n      <!-- each categories -->\n      ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.menu.categories, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n      ';
          r += Template7Helpers.js_if.call(ctx_2, "this.items.length", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n      <h3 class="menu-category text-uppercase">\n        <img src="static/cards.svg" width="12">\n        ';
              r += c(ctx_3.caption[lng.language], ctx_3);
              r += '\n      </h3> \n\n      <div class="list m-0">\n        <ul class=\'m-0\'>\n\n          <!-- each category.items -->\n          ';
              r += Template7Helpers.each.call(ctx_3, ctx_3.items, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n          ';
                  r += Template7Helpers.if.call(ctx_4, ctx_4.visible, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n\n          <li @click="toggleAllergens(\'';
                      r += c(ctx_5.id, ctx_5);
                      r += '\')">\n            <a href="#" class="item-link item-content">\n              <div class="item-media">\n                <div @click="showImage" \n                      data-categoriesIndex="';
                      r += c(ctx_5.catIndex, ctx_5);
                      r += '"\n                      data-index="';
                      r += c(data_5 && data_5.index, ctx_5);
                      r += '"\n                      class="menu-item-image menu-item-image-small" \n                      style="background-image: url(';
                      r += c(ctx_5.images[0] || 'static/no-image.png', ctx_5);
                      r += ')"></div>\n              </div>\n              <div class="item-inner">\n                <div class="mycaption item-';
                      r += c(ctx_5.id, ctx_5);
                      r += '-caption">';
                      r += c(ctx_5.caption, ctx_5);
                      r += '</div>\n                <div class="myprice">';
                      r += c(root.cur, ctx_5);
                      r += ' ';
                      r += c(ctx_5.price, ctx_5);
                      r += '</div>\n              </div>\n            </a>\n\n            <div class="allergens padding hidden" id="menu-item-';
                      r += c(ctx_5.id, ctx_5);
                      r += '">\n              <div class="item-';
                      r += c(ctx_5.id, ctx_5);
                      r += '-description">';
                      r += c(ctx_5.description, ctx_5);
                      r += '</div>\n              <div class="myallergens">\n                ';
                      r += Template7Helpers.if.call(ctx_5, ctx_5.glutenfree, {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += '<img width=\'24\' class="rounded" src="static/menu/glutenfree.png" alt=""/>';
                          return r;
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [ctx_4, ctx_3, ctx_2, ctx_1]
                      });
                      r += '\n                ';
                      r += Template7Helpers.if.call(ctx_5, ctx_5.takeaway, {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += '<img width=\'24\' class="rounded" src="static/menu/takeaway.png" alt=""/>';
                          return r;
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [ctx_4, ctx_3, ctx_2, ctx_1]
                      });
                      r += '\n                ';
                      r += Template7Helpers.if.call(ctx_5, ctx_5.delivery, {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += '<img width=\'24\' class="rounded" src="static/menu/delivery.png" alt=""/>';
                          return r;
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [ctx_4, ctx_3, ctx_2, ctx_1]
                      });
                      r += '\n                ';
                      r += Template7Helpers.if.call(ctx_5, ctx_5.onsite, {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += '<img width=\'24\' class="rounded" src="static/menu/onsite.png?v=!" alt=""/>';
                          return r;
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [ctx_4, ctx_3, ctx_2, ctx_1]
                      });
                      r += '\n              </div>\n\n              ';
                      r += Template7Helpers.if.call(ctx_5, ctx_5.hasAllergens, {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += '\n              <div class="text-align-center padding-top-half"><strong>';
                          r += c(root.lng.allergens_caption, ctx_6);
                          r += '</strong></div>\n              <div class="menu-item-allergens padding">\n\n\n                ';
                          r += Template7Helpers.each.call(ctx_6, ctx_6.allergens, {
                            hash: {},
                            data: data_6 || {},
                            fn: function (ctx_7, data_7) {
                              var r = '';
                              r += '\n                <div class="text-align-center padding-half">\n                  <img id="';
                              r += c(data_7 && data_7.key, ctx_7);
                              r += '" width="50" src="static/allergy-icons/';
                              r += c(data_7 && data_7.key, ctx_7);
                              r += '/';
                              r += c(data_7 && data_7.key, ctx_7);
                              r += '_red_200x200.png"/> <br>\n                  <div class="small">';
                              r += Template7Helpers.js.call(ctx_7, "lng.allergens[@key]", {
                                hash: {},
                                data: data_7 || {},
                                fn: function empty() {
                                  return '';
                                },
                                inverse: function empty() {
                                  return '';
                                },
                                root: root,
                                parents: [ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                              });
                              r += '</div>\n                </div>\n                ';
                              return r;
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                          });
                          r += '\n\n              </div>\n\n              ';
                          return r;
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [ctx_4, ctx_3, ctx_2, ctx_1]
                      });
                      r += '\n            </div>\n          </li>\n\n          ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [ctx_3, ctx_2, ctx_1]
                  });
                  r += ' \n          ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += ' <!-- end each category.items --> \n\n        </ul>\n      </div>\n      ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n      ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' <!-- end each categories -->\n\n    </div>\n  </div>\n';
      return r;
    }(this);
  },

  styleScoped: false
};
    